// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1xFkH","list":"PatternAutocomplete_list__1Zxna"};